import React, { useId } from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { Input, InputProps } from '@epoch-ui/components/Input';

import {
  FormField,
  FormControl,
  FormDescription,
  FormLabel,
  FormItem,
  FormMessage
} from '../../form';

export interface InputFieldProps extends InputProps {
  label?: string | React.ReactNode | React.ReactNode[];
  description?: string | React.ReactNode | React.ReactNode[];
  inputClassName?: string;
}

export const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  ({ name, label, description, className, inputClassName, ...props }, ref) => {
    const formCtx = useFormContext();
    const id = useId();

    return (
      <FormField
        control={formCtx.control}
        name={name || id}
        render={({ field, fieldState }): React.ReactElement => (
          <FormItem className={cn('tw-mt-4', className)}>
            {label && (
              <FormLabel className={cn('tw-mb-0', props.disabled && 'tw-opacity-40')}>
                {label}
              </FormLabel>
            )}
            {description && (
              <FormDescription className={cn('tw-mb-0', props.disabled && 'tw-opacity-40')}>
                {description}
              </FormDescription>
            )}
            <FormControl>
              <Input
                {...props}
                {...field}
                value={field.value || ''}
                className={cn('tw-mt-2', inputClassName)}
                error={!!fieldState.error}
                ref={ref}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);

InputField.displayName = 'InputField';
